import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import { initAuth } from './utils/auth';
import { loadConfig } from './utils/config';
import './style.css';

async function bootstrap() {
  await loadConfig();
  // Completes the Cognito redirect or ensures a valid session (redirecting to the hosted UI if needed).
  await initAuth();
  createApp(App).use(router).mount('#app');
}

bootstrap().catch((err: unknown) => {
  const message = err instanceof Error ? err.message : String(err);
  document.getElementById('app')!.innerHTML =
    `<div class="container"><div class="error-banner"></div><a href="/">Try again</a></div>`;
  document.querySelector('.error-banner')!.textContent = message;
});
